import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from '@/utils/request';
import GeneralTable from '@/components/GeneralTable';
import { code } from '@/utils/code';
export default {
  name: 'Index',
  components: {
    GeneralTable: GeneralTable
  },
  data: function data() {
    return {
      code: code,
      minValue: 0,
      fullscreenLoading: false,
      clientProp: [],
      clientPropItem: {},
      clientPropOptions: [],
      dialogClientPropVisible: false,
      dialogPropOptionVisible: false,
      c_is_virtual_list: [0, 1, 2],
      tableName: null,
      batchAddPropOptionContent: null,
      batchAddPropOptionVisible: false,
      columns: {},
      tables: [],
      commonProps: []
    };
  },
  computed: {
    clientName: function clientName() {
      return this.$store.state.user.clientName;
    },
    filterClientPropOptions: function filterClientPropOptions() {
      var clientPropOptions = this.clientPropOptions;
      var array = [];
      clientPropOptions.forEach(function (item) {
        if (!item.delete) {
          array.push(item);
        }
      });
      return array;
    },
    filterClientProp: function filterClientProp() {
      var clientProp = this.clientProp;
      var array = [];
      clientProp.forEach(function (item) {
        if (!item.delete) {
          array.push(item);
        }
      });
      return array;
    },
    dialogClientPropTitle: function dialogClientPropTitle() {
      var clientPropItem = this.clientPropItem;
      var title = '表名:' + this.tableName;
      if (clientPropItem) {
        title = title + ' 列名: ' + clientPropItem.c_code;
      }
      return title;
    }
  },
  created: function created() {
    // const loading = this.$loading({
    //   lock: true,
    //   text: this.$t('loading.default'),
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // })
    // const lang = this.$store.getters.language
    this.getAllTables();
    this.getCommonProps();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // 保存离开本页面时的查询条件，当再次进入本页面时回显
    // sessionStorage.setItem(window.location.href + '_LIST_QUERY', JSON.stringify(this.$refs.GeneralTable.getListQuery()))
    next();
  },
  watch: {
    clientPropItem: {
      handler: function handler(newName, oldName) {
        console.log(arguments);
        if (this.clientPropItem.c_code) {
          this.clientPropItem.c_label_code = 'prop.' + this.tableName + '.' + this.clientPropItem.c_code;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    canAddClientPropLabel: function canAddClientPropLabel(item) {
      if (isNull(item.client_label)) {
        return true;
      }
      return item.client_label.length < code.Language.length;
    },
    confirmClientPropItem: function confirmClientPropItem(item) {
      if (item.delete) {
        return;
      }
      var c_code = item.c_code;
      var c_label_code = item.c_label_code;
      if (isNull(c_code) || isNull(c_label_code)) {
        this.$message.warning('数据未填写完整，不能添加');
        return;
      }
      var client_label = item.client_label;
      for (var i = 0, length = client_label.length; i < length; i++) {
        if (client_label[i].delete) {
          return;
        }
        var c_label = client_label[i].c_label;
        if (isNull(c_label)) {
          this.$message.warning('数据未填写完整，不能添加');
          return;
        }
      }
      this.dialogClientPropVisible = false;
    },
    showOptionLabelAdd: function showOptionLabelAdd(item) {
      return isNull(item.client_label) || item.client_label.length < code.Language.length;
    },
    getFilterClientLabels: function getFilterClientLabels(client_labels) {
      var client_label = [];
      if (client_labels) {
        client_labels.forEach(function (item) {
          if (!item.delete) {
            client_label.push(item);
          }
        });
      }
      return client_label;
    },
    editOption: function editOption(item) {
      return item.c_is_option && !item.c_common_prop_id && !item.c_option_table;
    },
    getClientLabelByPropId: function getClientLabelByPropId(id, call_back) {
      var _this = this;
      request({
        url: 'client-table-prop/prop-option/' + id + '/client-label',
        method: 'get'
      }).then(function (res) {
        console.log(res);
        if (typeof call_back == 'function') {
          call_back.call(_this, res.data.data);
        }
      });
    },
    deleteClientLabel: function deleteClientLabel(item, client_label_item) {
      var _this2 = this;
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        if (!client_label_item.c_id) {
          item.client_label.remove(client_label_item);
        } else {
          request({
            url: 'client-table-prop/client-label/' + client_label_item.c_label_code + '/delete-check',
            method: 'post'
          }).then(function (res) {
            console.log(res);
            var code = res.data.code;
            if (code == '0') {
              _this2.$set(client_label_item, 'delete', true);
            } else {
              _this2.$message({
                message: res.data.message,
                type: 'warning'
              });
            }
          });
        }
      }).catch(function () {});
    },
    addClientLabel: function addClientLabel(clientPropItem, c_label, label_type) {
      var languages = code.Language;
      var client_label = clientPropItem.client_label;
      if (!client_label) {
        this.$set(clientPropItem, 'client_label', []);
        client_label = clientPropItem.client_label;
      }
      var client_label_language = {};
      if (client_label) {
        client_label.forEach(function (item) {
          client_label_language[item.c_language_id] = true;
        });
      }
      for (var i = 0, length = languages.length; i < length; i++) {
        if (!client_label_language[languages[i].key]) {
          var init_client_label = this.getInitClientLabel();
          init_client_label.c_label = c_label ? c_label : null;
          init_client_label.c_label_code = clientPropItem.c_label_code;
          init_client_label.c_language_id = languages[i].key;
          init_client_label.c_type = label_type || 'prop';
          client_label.push(init_client_label);
          break;
        }
      }
    },
    getInitClientLabel: function getInitClientLabel() {
      return {
        c_id: null,
        c_client_id: this.getClientId(),
        c_label: null,
        c_label_code: null,
        c_language_id: null,
        c_type: null
      };
    },
    getClientLabelByCode: function getClientLabelByCode(code, call_back) {
      var _this3 = this;
      request({
        url: 'client-table-prop/client-label/' + code + '/delete-check',
        method: 'post'
      }).then(function (res) {
        console.log(res);
        if (typeof call_back == 'function') {
          call_back.call(_this3, res.data.data);
        }
      });
    },
    confirmPropOptionDialog: function confirmPropOptionDialog() {
      this.dialogPropOptionVisible = false;
    },
    batchAddPropOption: function batchAddPropOption() {
      this.batchAddPropOptionVisible = true;
    },
    cancelBatchAddPropOption: function cancelBatchAddPropOption() {
      this.batchAddPropOptionContent = null;
      this.batchAddPropOptionVisible = false;
    },
    confirmBatchAddPropOption: function confirmBatchAddPropOption() {
      var batchAddPropOptionContent = this.batchAddPropOptionContent;
      if (isNull(batchAddPropOptionContent)) {
        return;
      }
      var list = batchAddPropOptionContent.split(/[\n\r]/);
      console.log(list);
      var __this = this;
      list.forEach(function (item) {
        if (isNull(item)) {
          return;
        }
        var insert_option_item = __this.addPropOption();
        __this.addClientLabel(insert_option_item, item, 'option');
      });
      this.batchAddPropOptionContent = null;
      this.batchAddPropOptionVisible = false;
    },
    addPropOption: function addPropOption() {
      var index = 1;
      var c_display_order = 1;
      var suffix = '';
      for (var i = 0, length = this.clientPropOptions.length; i < length; i++) {
        var _c_label_code = this.clientPropOptions[i].c_label_code;
        if (!_c_label_code) {
          this.$message.warning('数据未填写完整，不能添加');
          return;
        }
        var _code = _c_label_code.replace(/.*\./img, '');
        if (!suffix) {
          suffix = _code.replace(/\d*$/img, '');
        }
        index = Math.max(index, parseInt(_code.replace(/^[a-zA-Z]*/img, '')));
        c_display_order = Math.max(c_display_order, parseInt(this.clientPropOptions[i].c_display_order));
      }
      var clientPropItem = this.clientPropItem;
      var c_label_code = 'option.' + this.tableName + '.' + clientPropItem.c_code + '.' + suffix + (index + 1);
      var add_option_item = {
        c_id: null,
        c_client_id: this.getClientId(),
        c_prop_id: null,
        c_label_code: c_label_code,
        c_parent_id: null,
        c_display_order: c_display_order + 1,
        c_common_option_value: null
      };
      this.clientPropOptions.unshift(add_option_item);
      return add_option_item;
    },
    getClientPropOptionByPropId: function getClientPropOptionByPropId(prop_id) {
      var _this4 = this;
      request({
        url: 'client-table-prop/prop-option/' + prop_id,
        method: 'get'
      }).then(function (res) {
        console.log(res);
        _this4.clientPropOptions = res.data.data;
        _this4.dialogPropOptionVisible = true;
        _this4.getClientLabelByPropId(prop_id, function (data) {
          var obj = {};
          data.forEach(function (item) {
            var c_label_code = item.c_label_code;
            if (isNull(obj[c_label_code])) {
              obj[c_label_code] = [];
            }
            obj[c_label_code].push(item);
          });
          var __this = this;
          this.clientPropOptions.forEach(function (item) {
            var client_label = obj[item.c_label_code];
            __this.$set(item, 'client_label', client_label || []);
          });
          this.clientPropItem.client_option = this.clientPropOptions;
          console.log(this.clientPropOptions);
        });
      });
    },
    getClientPropByTableName: function getClientPropByTableName(name) {
      var _this5 = this;
      request({
        url: 'client-table-prop/' + name,
        method: 'get'
      }).then(function (res) {
        console.log(res);
        _this5.clientProp = res.data.data;
        _this5.getColumnsByTableName(name);
      });
    },
    editClientPropOption: function editClientPropOption(index, row) {
      this.clientPropItem = row;
      if (this.clientPropItem.c_id) {
        this.getClientPropOptionByPropId(this.clientPropItem.c_id);
      } else {
        this.dialogPropOptionVisible = true;
      }
    },
    editClientProp: function editClientProp(index, row) {
      this.clientPropItem = row;
      this.dialogClientPropVisible = true;
      this.getClientLabelByCode(this.clientPropItem.c_label_code, function (data) {
        if (!isNull(data)) {
          this.$set(this.clientPropItem, 'client_label', data);
        }
      });
    },
    deleteClientPropOption: function deleteClientPropOption(index, row) {
      var _this6 = this;
      var newDatas = [];
      var h = this.$createElement;
      newDatas.push(h('p', null, '是否要删除?'));
      newDatas.push(h('p', null, 'Label Code:' + row.c_label_code));
      this.$confirm(h('div', null, newDatas), '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        if (isNull(row.c_id)) {
          _this6.clientPropOptions.remove(row);
        } else {
          _this6.$set(row, 'delete', true);
        }
      }).catch(function () {});
    },
    deleteClientProp: function deleteClientProp(index, row) {
      var _this7 = this;
      var newDatas = [];
      var h = this.$createElement;
      newDatas.push(h('p', null, '是否要删除?'));
      newDatas.push(h('p', null, 'Label Code:' + row.c_label_code));
      newDatas.push(h('p', null, 'Code:' + row.c_code));
      this.$confirm(h('div', null, newDatas), '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        if (isNull(row.c_id)) {
          _this7.clientProp.remove(row);
        } else {
          _this7.$set(row, 'delete', true);
        }
      }).catch(function () {});
    },
    checkClientProp: function checkClientProp() {
      var clientProp = this.clientProp;
      for (var i = 0, length = clientProp.length; i < length; i++) {
        if (clientProp[i].delete) {
          continue;
        }
        var c_code = clientProp[i].c_code;
        var c_label_code = clientProp[i].c_label_code;
        if (isNull(c_code) || isNull(c_label_code)) {
          return '数据未填写完整，不能添加';
        }
      }
    },
    getClientId: function getClientId() {
      return this.$store.state.user.clientId;
    },
    save: function save() {
      var _this8 = this;
      var check = this.checkClientProp();
      if (check) {
        this.$message.warning(check);
        return;
      }
      request({
        url: 'client-table-prop/save',
        method: 'post',
        data: this.clientProp
      }).then(function (res) {
        if (res.data.code != '0') {
          _this8.$message.warning(res.data.message);
        } else {
          _this8.getClientPropByTableName(_this8.tableName);
        }
        console.log(res);
      });
    },
    addClientProp: function addClientProp() {
      for (var i = 0, length = this.clientProp.length; i < length; i++) {
        var item = this.clientProp[i];
        if (isNull(item.c_label_code) || isNull(item.c_code)) {
          this.$message.warning('数据未填写完整，不能添加');
          return;
        }
      }
      this.clientPropItem = this.getInitClientPropItem();
      this.clientProp.unshift(this.clientPropItem);
    },
    getInitClientPropItem: function getInitClientPropItem() {
      return {
        c_id: null,
        c_client_id: this.getClientId(),
        c_table_name: this.tableName,
        c_code: null,
        c_label_code: null,
        c_is_custom: null,
        c_parent_id: null,
        c_prop_group_id: null,
        c_type: null,
        c_is_option: null,
        c_width: null,
        c_fixed: null,
        c_visible: null,
        c_sortable: null,
        c_queryable: null,
        c_editable: null,
        c_batcheditable: null,
        c_rec_creator: null,
        c_rec_create_time: null,
        c_rec_revisor: null,
        c_rec_revise_time: null,
        c_tree_url: null,
        c_option_key: null,
        c_option_label: null,
        c_options_url: null,
        c_display_order: null,
        c_linkedit: null,
        c_option_table: null,
        c_common_prop_id: null,
        c_is_virtual: 0
      };
    },
    onCommonPropSelect: function onCommonPropSelect(item, prop_id) {
      if (prop_id) {
        this.getCommonPropOptionClientLabelByPropId(item, prop_id);
      } else {
        this.$set(item, '__common_prop_option_client_label', []);
      }
    },
    onSelectTable: function onSelectTable(value) {
      this.getClientPropByTableName(value);
    },
    getColumnsByTableName: function getColumnsByTableName(name) {
      var _this9 = this;
      request({
        url: 'client-table-prop/columns/' + name,
        method: 'get'
      }).then(function (res) {
        var filter_data = res.data.data.filter(function (item) {
          if (item == 'c_rec_creator' || item == 'c_rec_create_time' || item == 'c_rec_revisor' || item == 'c_rec_revise_time') {
            return false;
          }
          return true;
        });
        _this9.columns[name] = filter_data;
        var __this = _this9;
        if (_this9.clientProp.length == 0) {
          filter_data.forEach(function (item) {
            var initClientPropItem = __this.getInitClientPropItem();
            initClientPropItem.c_code = item;
            initClientPropItem.c_label_code = 'prop.' + name + '.' + item;
            __this.clientProp.push(initClientPropItem);
          });
        }
        console.log(res);
      });
    },
    getAllTables: function getAllTables() {
      var _this10 = this;
      request({
        url: 'client-table-prop/tables',
        method: 'get'
      }).then(function (res) {
        if (res.data.code == '0') {
          _this10.tables = res.data.data;
        } else {
          _this10.$message.warning(res.data.message);
        }
        console.log(res);
      });
    },
    getCommonProps: function getCommonProps() {
      var _this11 = this;
      request({
        url: 'client-table-prop/common-props',
        method: 'get'
      }).then(function (res) {
        if (res.data.code == '0') {
          _this11.commonProps = res.data.data;
        } else {
          _this11.$message.warning(res.data.message);
        }
        console.log(res);
      });
    },
    getCommonPropOptionClientLabelByPropId: function getCommonPropOptionClientLabelByPropId(item, prop_id) {
      var _this12 = this;
      request({
        url: 'client-table-prop/common-prop-option/' + prop_id + '/client-label',
        method: 'get'
      }).then(function (res) {
        if (res.data.code == '0') {
          _this12.$set(item, '__common_prop_option_client_label', res.data.data);
        } else {
          _this12.$message.warning(res.data.message);
        }
        console.log(res);
      });
    },
    refreshDD: function refreshDD() {
      var loading = this.$loading({
        lock: true,
        text: this.$t('loading.default'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var lang = this.$store.getters.language;
      if (this.refreshDataDictionary(lang)) {
        loading.close();
      }
    },
    refreshDataDictionary: function () {
      var _refreshDataDictionary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([this.refreshTableDD(lang), this.refreshCodeDD(lang)]);
            case 2:
              return _context.abrupt("return", true);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function refreshDataDictionary(_x) {
        return _refreshDataDictionary.apply(this, arguments);
      }
      return refreshDataDictionary;
    }(),
    refreshTableDD: function refreshTableDD(lang) {
      this.$store.dispatch('tableDataDictionary/refreshTableDataDictionary', lang).then(function () {
        console.log('Refresh tableDataDictionary success');
      }).catch(function () {
        console.log('Refresh tableDataDictionary failed');
      });
    },
    refreshCodeDD: function refreshCodeDD(lang) {
      this.$store.dispatch('codeDataDictionary/refreshCodeDataDictionary', lang).then(function () {
        console.log('Refresh codeDataDictionary success');
      }).catch(function () {
        console.log('Refresh codeDataDictionary failed');
      });
    }
  }
};